import { cx } from '@/utils/strings'
import Link from '@/components/link-component'

export type ArticleBreadcrumbProps = {
  breadcrumb: { name: string; path?: string }[]
  className?: string
}

export default function ArticleBreadcrumb({ breadcrumb, className }: ArticleBreadcrumbProps) {
  return (
    <ol className={cx(`mb-5 list-none flex flex-row text-[15px] leading-tight uppercase`, className)}>
      {breadcrumb.map(({ name, path }, i) => (
        <li key={name} className={cx(i > 0 && `px-2 text-secondary-500 dark:text-secondary-300 relative pl-8`)}>
          {i === 0 ? (
            <Link to={path} title={name}>
              <b>{name}</b>
            </Link>
          ) : (
            <>
              <span className="font-bwi absolute left-2 top-[1px]">&#xe91b;</span>
              {name}
            </>
          )}
        </li>
      ))}
    </ol>
  )
}
